import React from 'react';
import { Link } from 'react-router-dom';
const slides = [
    {
        title: "Digital Agronomic servcies",
        mobileText: "Record keeping on the go",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751380764/image_g8t7yx.png"

    },
    {
        title: "Disease Surveillance",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751380762/image-1_p0gfth.png"

    },
    {
        title: "Environmental control systems",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751380763/image-2_crixjs.png"

    },
    {
        title: "On-Demand veterinary services",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751380764/image-3_tn3oor.png"


    },
    {
        title: "Water Management ",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751452790/image_hmll2r.png"



      },
      {
        title: "Green House technology",
        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751452791/Rectangle_34641498_mffi44.png"



      },
      {
        title: "-",
     imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751452791/Rectangle_34641496_rfny00.png"


      },
      {
        title: "-",
     

        imageUrl: "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1751452790/Rectangle_34641497_hgfv1a.png"

      },
 

];

const SolutionsGrid = () => {
    return (
        <div className="relative bg-white md:py-8 py-4 px-4 md:px-20">
            <div className='md:px-10'>
                <div className='flex justify-between  '>
                    <h1 className="text-[14px] md:text-[36px] font-bold  text-black md:mb-3">INSIGHTS & INNOVATIONS</h1>
                  
                </div>
                <h1 className="text-[10px] md:text-[32px] font-medium md:mb-5 mb-2 text-black" style={{lineHeight:'1.10'}}>
                "Farmers are speaking out, hear their success stories and discover how the Farmnet app is making a difference in their lives."
                </h1>
            </div>
            <h1 className="text-[12px] md:text-[36px] font-bold  text-black  mb-3 md:px-10">SOLUTIONS</h1>

            {/* Grid Layout for the Cards */}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 md:gap-y-4 gap-y-2  gap-x-2 md:px-10">
                {slides.map((slide, index) => (
                    <Link to={`/innovation${index + 1}`}>
                    <div
                        key={index}
                        className=" w-full h-[110px] sm:w-[45%] md:w-[570px] md:h-[336px] rounded-md overflow-hidden relative cursor-pointer"
                    >
                       

                        {/* Centered Image */}
                            <img
                                src={slide.imageUrl}
                                alt={slide.title}
                                className="object-contain rounded-md "
                            />

                        {/* Text Content */}
                

                     
                    </div>
         <div className='flex justify-between items-center md:py-2 py-1'>
         <div>
<h1 className='md:text-[20px] text-[8px] font-normal italic'>{slide.title}</h1>
         </div>
         <div>
        <div className='flex md:gap-2 gap-1 justify-center md:mt-2'>
          <div className="bg-[#2E453D] md:ml-0 ml-2 text-white font-normal md:px-6 px-2 rounded-md md:rounded-[30px] w-[70px] h-[15px] md:w-[150px] md:text-[18px] text-[6px] md:h-[40px] mt-0 md:-mt-[1px] flex justify-between items-center">
            See More
          </div>
          <div className='bg-[#2E453D] w-[15px] h-[15px] md:w-[40px] md:h-[40px] flex justify-center md:mt-0 mr-2 rounded-full'> 
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
              alt="Arrow"
              className="md:w-6 md:h-6 w-3 h-3 mt-2 md:flex hidden"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748783006/Expand_right_gzn0vr.png"
              alt="Arrow"
              className="w-2 h-2 mt-1 md:hidden flex"
            /> 
          </div>
        </div>
      </div>
         </div>
              </Link>

                ))}
            </div>
            <div className=" md:px-10">
  <h1 className="text-[18px] md:text-[32px] font-bold mt-8 mb-4 text-black">
    Download App
  </h1>
  <div className="flex flex-row sm:space-x-6 space-x-2  items-center sm:space-y-0">
    <a href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share" alt="none">   
             <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png" className="h-[25px] md:w-[280px] md:h-[180px]" alt="App Store" />    
             <p className="md:text-[14px] text-[6px] md:-mt-12 md:pl-5 font-normal md:px-1">
             Click to download App
  </p>
     </a>
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
      alt="Google Play"
      className="h-[30px] md:h-[75px] object-contain"
    />
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image-1_wdvhie.png"
      alt="QR Code"
      className="h-[30px] md:h-[75px] object-contain"
    />
  </div>
</div>
        </div>
    );
};

export default SolutionsGrid;
